module.exports = __webpack_public_path__ + "static/media/cliente-cpf.6363eb27.svg";